export default function loadOpenGraphImage() {
    let ogImageUrl = '';

    let $hero = document.querySelector('.hero');
    if (ogImageUrl === '' && $hero !== null) {
        ogImageUrl = window.getComputedStyle($hero)?.backgroundImage?.replace('url("', '').replace('")', '');
    }

    if (ogImageUrl === '') {
        let $eventImage = document.querySelector('.info-detail__left-card img');
        if (ogImageUrl === '' && $eventImage !== null && $eventImage.src !== '') {
            ogImageUrl = $eventImage.src;
        }
    }

    if (ogImageUrl === '') {
        let $eventImage = document.querySelector('.info-detail__left-card .info-detail__left-image');
        if (ogImageUrl === '' && $eventImage !== null && $eventImage.style.backgroundImage !== '') {
            ogImageUrl = $eventImage.style.backgroundImage;
        }
    }

    if (ogImageUrl === '') {
        let $eventImage = document.querySelector('.article-image img');
        if (ogImageUrl === '' && $eventImage !== null && $eventImage.src !== '') {
            ogImageUrl = $eventImage.src;
        }
    }

    if (ogImageUrl === '') {
        let $productImage = document.querySelector('.product-container .preview-image');
        if (ogImageUrl === '' && $productImage !== null && $productImage.src !== '') {
            ogImageUrl = $productImage.src;
        }
    }

    if (ogImageUrl !== '') {
        let $ogImageElement = document.querySelector('meta[name="ogImage"]');
        if ($ogImageElement !== null) {
            $ogImageElement.setAttribute('content', ogImageUrl);
        }
    }
}
